import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div
                      className="col-md-12 center-column content-with-background"
                      id="content"
                    >
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">
                              Delivery Information
                            </h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-sections">
                                  {/* 1. UK Mainland Delivery */}
                                  <div className="pdh-policy-section">
                                    <ol start={1}>
                                      <li className="pdh-policy-section-title">
                                        UK Mainland Delivery
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        We offer the following delivery options
                                        for orders within the UK Mainland:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          <strong>Standard Delivery:</strong>{" "}
                                          £3.95 (2-4 working days).
                                        </li>
                                        <li>
                                          <strong>Next Day Delivery:</strong>{" "}
                                          £5.95 (Available for orders placed
                                          before 2pm, Mon-Fri).
                                        </li>
                                        <li>
                                          <strong>Free Delivery:</strong>{" "}
                                          Available on all orders over £40.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  {/* 2. International Delivery */}
                                  <div className="pdh-policy-section">
                                    <ol start={2}>
                                      <li className="pdh-policy-section-title">
                                        International Delivery
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        We ship worldwide! Please note that
                                        delivery times and costs vary depending
                                        on the destination:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          <strong>Europe:</strong> £15.00 (5-7
                                          working days).
                                        </li>
                                        <li>
                                          <strong>Rest of the World:</strong>{" "}
                                          £25.00 (7-14 working days).
                                        </li>
                                      </ul>
                                      <p className="pdh-policy-text">
                                        Customs, duties, and local taxes may
                                        apply for international orders. These
                                        are the responsibility of the customer.
                                      </p>
                                    </div>
                                  </div>

                                  {/* 3. Order Tracking */}
                                  <div className="pdh-policy-section">
                                    <ol start={3}>
                                      <li className="pdh-policy-section-title">
                                        Order Tracking
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        Once your order has been dispatched, you
                                        will receive a shipping confirmation
                                        email containing a tracking number. You
                                        can use this tracking number to monitor
                                        the progress of your delivery.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Delivery;
